import React, { useState, useEffect } from "react";
import axios from "axios";
import BackButton from "../component/BackButton";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from '../component/Sidebar';
import toast from "react-hot-toast";

const convertTo24Hour = (time12h) => {
  if (!time12h) return "";
  const [time, period] = time12h.split(" ");
  let [hours, minutes] = time.split(".");
  let h = parseInt(hours);
  if (period === "PM" && h !== 12) h += 12;
  if (period === "AM" && h === 12) h = 0;
  return `${h.toString().padStart(2, "0")}:${minutes}`;
};

const Training = () => {
  const [formData, setFormData] = useState({
    trainingCode: "",
    trainingTitle: "",
    trainingCategory: "",
    departments: [], 
    startTime: "",   
    endTime: "",
    trainerName: "",
    internalExternal: "INTERNAL",
    trainingType: "",
    frequency: "",
    mandatoryOptional: "MANDATORY",
    description: "",
    trainingDate: "", 
    trainingTime: "",
    timePeriod: ""
  });

  const [departments, setDepartments] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [file, setFile] = useState(null);
  // Add these lines near your existing useState definitions
const [selectedDepts, setSelectedDepts] = useState([]); 
const [docInputs, setDocInputs] = useState([{ id: Date.now(), file: null }]);
  const [documentName, setDocumentName] = useState("");

  const navigate = useNavigate();
  const location = useLocation();
  const editingTraining = location.state?.training || null;
  const isEditMode = Boolean(editingTraining?._id);

  const categories = [
    "NABH ORIENTATION", "FIRE SAFETY", "INFECTION CONTROL", 
    "BIOMEDICAL WASTE MANAGEMENT", "PATIENT SAFETY GOALS", 
    "BASIC LIFE SUPPORT (BLS)", "ADVANCED LIFE SUPPORT (ACLS)", 
    "MEDICATION SAFETY", "HR POLICIES", "IT SECURITY", "DEPARTMENT SPECIFIC TRAINING"
  ];

  const handleDateChange = (e) => {
  let value = e.target.value.replace(/\D/g, ""); // Remove non-numbers
  if (value.length > 8) value = value.slice(0, 8);

  let formattedDate = value;
  if (value.length > 4) {
    formattedDate = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4)}`;
  } else if (value.length > 2) {
    formattedDate = `${value.slice(0, 2)}/${value.slice(2)}`;
  }
  setFormData(prev => ({ ...prev, trainingDate: formattedDate }));
};

const addDocField = () => {
  setDocInputs([...docInputs, { id: Date.now(), file: null }]);
};

const handleFileChange = (index, event) => {
  const file = event.target.files[0];

  if (!file) return;

  // ❌ SIZE CHECK
  if (!validateFileSize(file)) return;

  const newDocs = [...docInputs];
  newDocs[index].file = file;
  setDocInputs(newDocs);
};
const handleTimeChange = (e) => {
  let value = e.target.value.replace(/\D/g, "");
  if (value.length > 4) value = value.slice(0, 4);

  let formattedTime = value;
  if (value.length > 2) {
    formattedTime = `${value.slice(0, 2)}:${value.slice(2)}`;
  }
  setFormData(prev => ({ ...prev, trainingTime: formattedTime }));
};
  useEffect(() => {
    const fetchData = async () => {
      try {
        const baseRequests = [
          axios.get("/api/departments"),
          axios.get("/api/employees")
        ];
        const editOrIdRequest = isEditMode
          ? axios.get(`/api/trainings/${editingTraining._id}`)
          : axios.get("/api/trainings/next-id");
        const [deptRes, empRes, trainingRes] = await Promise.all([...baseRequests, editOrIdRequest]);

        setDepartments(deptRes.data || []);
        setEmployees(empRes.data || []);

        if (isEditMode) {
          const training = trainingRes.data || editingTraining;
          const assigned = Array.isArray(training.selectedEmployees) ? training.selectedEmployees : [];
          const assignedAll = assigned.includes("ALL");
          setFormData({
            trainingCode: training.trainingId || "",
            trainingTitle: training.trainingTitle || "",
            trainingCategory: training.trainingCategory || "",
            departments: training.departments || [],
           startTime: convertTo24Hour(training.startTime), 
            endTime: convertTo24Hour(training.endTime),
            trainerName: training.trainerName || "",
            internalExternal: training.internalExternal || "INTERNAL",
            trainingType: training.trainingType || "",
            frequency: training.frequency || "",
            mandatoryOptional: training.mandatoryOptional || "MANDATORY",
            description: training.description || "",
            trainingDate: training.trainingDate || "",
            trainingTime: training.trainingTime || "",
            timePeriod: training.timePeriod || ""
          });
          setSelectAll(assignedAll);
          setSelectedEmployees(assignedAll ? [] : assigned);
          setDocumentName(training.documentName || training.documentPath?.split(/[\\/]/).pop() || "");
          if (training.documentNames && training.documentNames.length > 0) {
        setDocInputs(training.documentNames.map((name, i) => ({ 
            id: Date.now() + i, 
            name: name, // This shows the filename in the UI
            file: null 
        })));
    }
        } else {
          setFormData(prev => ({ ...prev, trainingCode: trainingRes.data.nextId }));
        }
      } catch (err) {
        toast.error("Error loading master data");
      }
    };
    fetchData();
  }, [editingTraining, isEditMode]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value.toUpperCase() }));
  };

  const getEmployeeKeys = (emp) =>
    [emp.employeeUserId, emp._id, emp.employeeID].filter(Boolean);

  const getEmployeeSelectionValue = (emp) =>
    emp.employeeUserId || emp._id || emp.employeeID;

  const isEmployeeSelected = (emp) => {
    const keys = getEmployeeKeys(emp);
    return selectedEmployees.some(id => keys.includes(id));
  };

  const handleEmployeeToggle = (emp) => {
    const keys = getEmployeeKeys(emp);
    const value = getEmployeeSelectionValue(emp);
    if (isEmployeeSelected(emp)) {
      setSelectedEmployees(selectedEmployees.filter(id => !keys.includes(id)));
    } else {
      setSelectedEmployees([...selectedEmployees, value]);
    }
  };
  const validateFileSize = (file) => {
  const maxSize = 1 * 1024 * 1024; // 1 MB

  if (file && file.size > maxSize) {
    toast.error("Upload only max 1 MB file allowed");
    return false;
  }
  return true;
};

const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();

    // Helper: Convert 24h (HH:mm) to 12h format (hh.mm AM/PM)
    const convertTo12Hour = (time24) => {
        if (!time24) return "";
        let [hours, minutes] = time24.split(':');
        let h = parseInt(hours);
        let period = h >= 12 ? 'PM' : 'AM';
        h = h % 12 || 12;
        return `${h.toString().padStart(2, '0')}.${minutes} ${period}`;
    };

    // 1. Append all standard form fields (excluding the ones handled below)
    Object.keys(formData).forEach((key) => {
        if (!['startTime', 'endTime', 'departments', 'selectedEmployees'].includes(key)) {
            data.append(key, formData[key]);
        }
    });

    // 2. Set formatted 12-hour times
    data.set("startTime", convertTo12Hour(formData.startTime));
    data.set("endTime", convertTo12Hour(formData.endTime));

    // 3. Departments: Send as clean JSON string
    data.set("departments", JSON.stringify(formData.departments));

    // 4. Employees: Send as clean JSON string
    data.set("selectedEmployees", JSON.stringify(selectAll ? ["ALL"] : selectedEmployees));

    // 5. DOCUMENT HANDLING (The Merge Logic)
    docInputs.forEach((item) => {
        // If it's an existing file (has a name), send it to the "existing" bucket
        if (item.name) {
            data.append("existingDocumentNames", item.name);
            data.append("existingDocumentPaths", item.name); // Using name as path
        }
        // If it's a newly uploaded file (has a file object), send it to the "new" bucket
        if (item.file) {
            data.append("documents", item.file);
        }
    });

    try {
        const config = { headers: { "Content-Type": "multipart/form-data" } };
        if (isEditMode) {
            await axios.put(`/api/trainings/${editingTraining._id}`, data, config);
            toast.success("Training Updated Successfully");
        } else {
            await axios.post("/api/trainings", data, config);
            toast.success("Training Saved Successfully");
        }
        navigate("/TrainingList");
    } catch (err) {
        toast.error("Failed to save training");
    }
};
// Change 'emp.departmentName' to match the field name in your employee database
const filteredEmployees = (formData.departments.length === 0 || formData.departments.length === departments.length)
    ? employees 
    : employees.filter(emp => {
        // We use departmentName because that is what is in your database
        const empDept = (emp.departmentName || "").toString().toUpperCase().trim();
        return formData.departments.some(selected => selected.toUpperCase().trim() === empDept);
    });
  return (
    <div className="min-h-screen bg-zinc-300 flex flex-col md:flex-row">
      <Sidebar />
      <div className="flex-1 p-2">
        <div className="bg-white shadow-lg rounded-lg p-4">
          <h2 className="text-xl font-bold mb-3 text-center text-black uppercase">{isEditMode ? "Edit Training Entry" : "New Training Entry"}</h2>
          <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-4 gap-3">
            
            <div>
              <label className="block text-xs font-bold uppercase">Training Code</label>
              <input name="trainingCode" value={formData.trainingCode} disabled className="w-full p-1 border border-gray-300 rounded text-sm bg-gray-100" />
            </div>

            {['trainingTitle', 'trainerName', 'trainingType', 'frequency'].map(field => (
              <div key={field}>
                <label className="block text-xs font-bold uppercase">{field.replace(/([A-Z])/g, ' $1')}</label>
                <input name={field} value={formData[field]} onChange={handleInputChange} className="w-full p-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-sky-300" required />
              </div>
            ))}

            <div>
              <label className="block text-xs font-bold uppercase">Date (DD/MM/YYYY)</label>
              <input 
                name="trainingDate" 
                value={formData.trainingDate} 
                onChange={handleDateChange} 
                placeholder="DD/MM/YYYY"
                maxLength={10}
                className="w-full p-1 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-sky-300" 
                required 
              />
            </div>

          
            <div className="grid grid-cols-2 gap-2 md:col-span-2">
              <div>
                <label className="block text-xs font-bold uppercase">Start Time</label>
                <input type="time" name="startTime" value={formData.startTime} 
                      onChange={handleInputChange} className="w-full p-1 border rounded text-sm" required />
              </div>
              <div>
                <label className="block text-xs font-bold uppercase">End Time</label>
                <input type="time" name="endTime" value={formData.endTime} 
                      onChange={handleInputChange} className="w-full p-1 border rounded text-sm" required />
              </div>
            </div>

            <div>
              <label className="block text-xs font-bold uppercase">Training Category</label>
              <select name="trainingCategory" value={formData.trainingCategory} onChange={handleInputChange} className="w-full p-1 border border-gray-300 rounded text-sm" required>
                <option value="">SELECT</option>
                {categories.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>

            <div>
              <label className="block text-xs font-bold uppercase">Departments</label>
              <div className="border p-2 max-h-24 overflow-y-auto text-sm">
                <label className="block">
                  <input type="checkbox" 
                    checked={formData.departments.length === departments.length} 
                    onChange={(e) => {
                      setFormData(prev => ({ 
                        ...prev, 
                        departments: e.target.checked ? departments.map(d => d.deptName) : [] 
                      }));
                    }} 
                  /> ALL
                </label>
                {departments.map(d => (
                  <label key={d._id} className="block">
                    <input type="checkbox" 
                      checked={formData.departments.includes(d.deptName)} 
                      onChange={(e) => {
                        const updated = e.target.checked 
                          ? [...formData.departments, d.deptName] 
                          : formData.departments.filter(name => name !== d.deptName);
                        setFormData(prev => ({ ...prev, departments: updated }));
                      }} 
                    /> {d.deptName}
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-xs font-bold uppercase">Int/Ext</label>
              <select name="internalExternal" value={formData.internalExternal} onChange={handleInputChange} className="w-full p-1 border border-gray-300 rounded text-sm">
                <option value="INTERNAL">INTERNAL</option>
                <option value="EXTERNAL">EXTERNAL</option>
              </select>
            </div>

            <div>
              <label className="block text-xs font-bold uppercase">Status</label>
              <select name="mandatoryOptional" value={formData.mandatoryOptional} onChange={handleInputChange} className="w-full p-1 border border-gray-300 rounded text-sm">
                <option value="MANDATORY">MANDATORY</option>
                <option value="OPTIONAL">OPTIONAL</option>
              </select>
            </div>

        {/* UPDATED EMPLOYEE MAPPING - NOW ALWAYS VISIBLE */}
        <div className="md:col-span-4 border p-2 rounded">
          <label className="flex items-center gap-2 mb-1">
            <input type="checkbox" checked={selectAll} onChange={() => setSelectAll(!selectAll)} />
            <span className="text-xs font-bold uppercase">Select All Employees</span>
          </label>
          
          <div className="grid grid-cols-2 md:grid-cols-6 gap-1 max-h-24 overflow-y-auto border p-1">
            {filteredEmployees.map(emp => (
              <label key={emp._id} className="text-[10px] flex items-center gap-1">
                <input 
                  type="checkbox" 
                  checked={selectAll || isEmployeeSelected(emp)} 
                  disabled={selectAll} 
                  onChange={() => handleEmployeeToggle(emp)} 
                />
                {`${emp.firstName || ""} ${emp.lastName || ""}`.toUpperCase()}
              </label>
            ))}
          </div>
            </div>

            <div className="md:col-span-4 border p-2 rounded">
         
           <div className="flex justify-between items-center mb-2">
                <label className="text-xs font-bold uppercase">
                  Upload Documents
                </label>

                <span className="text-[10px] text-red-500 font-semibold">
                  Max size: 1 MB per file
                </span>
             
            <button 
              type="button" 
              onClick={addDocField}
              className="text-[10px] bg-blue-600 text-white px-2 py-1 rounded hover:bg-blue-700"
            >
              + ADD DOCUMENT
            </button>
          </div>

          <div className="space-y-2">
        {docInputs.map((input, index) => (
        <div key={input.id} className="flex gap-2 items-center mb-1">
          {input.name ? (
              // Existing File: Show name + Delete Button
              <div className="flex w-full justify-between items-center bg-gray-50 p-1 border rounded text-xs">
                  <span className="text-blue-600">{input.name}</span>
                  <button 
                      type="button" 
                      onClick={() => {
                          const newDocs = docInputs.filter((_, i) => i !== index);
                          setDocInputs(newDocs);
                      }}
                      className="text-red-500 font-bold px-2"
                  >
                      DELETE
                  </button>
              </div>
          ) : (
              // New File Upload
              <input type="file" onChange={(e) => handleFileChange(index, e)} className="w-full text-xs border p-1 rounded" />
          )}
        </div>
      ))}
        </div>
        </div>
            <div className="md:col-span-2">
              <label className="block text-xs font-bold uppercase">Description</label>
              <input name="description" value={formData.description} onChange={handleInputChange} className="w-full p-1 border border-gray-300 rounded text-sm" />
            </div>

            <div className="col-span-full flex justify-between items-center pt-2 border-t">
              <BackButton />
              <button type="submit" className="bg-teal-600 text-white px-4 py-1 rounded text-sm hover:bg-teal-700 font-bold uppercase">{isEditMode ? "Update" : "Save"}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Training;


